import { render } from "./DCalendarSettingsModal.vue?vue&type=template&id=7bbded29"
import script from "./DCalendarSettingsModal.vue?vue&type=script&lang=js"
export * from "./DCalendarSettingsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__